import React, { FC } from "react";
import "./SnackChip.scss";
import getClasses from "../../utils/getClasses";

export type IThemeSnackChip =
  | "info"
  | "warning"
  | "success"
  | "error"
  | "filters"
  | "info-secondary"
  | "disabled"
  | "resource"
  | "draft"
  | "is-linked-issue"
  | "issue";

interface Props {
  theme?: IThemeSnackChip;
  label: string;
  backgroundColor?: string;
  color?: string;
  filters?: boolean;
  border?: string;
  isActive?: boolean;
  handleCLick?: () => void;
  iconLeft?: JSX.Element | string;
  iconRight?: JSX.Element | string;
  fontWeight?: number;
  options?: {
    colorTextNeutral?: boolean;
  };
  borderRadius?: "sm" | "md";
  customSpanClass?: string;
}
const SnackChip: FC<Props> = ({
  theme,
  backgroundColor,
  color,
  iconLeft,
  iconRight,
  label,
  isActive,
  filters,
  options,
  handleCLick,
  borderRadius = "md",
  customSpanClass,
}) => {
  const renderIcon = (icon: JSX.Element | string) =>
    typeof icon === "string" ? (
      <i style={{ color: color }} className={`icon-chip ${icon}`} />
    ) : (
      icon
    );
  return filters ? (
    <button
      onClick={() => handleCLick && handleCLick()}
      type="button"
      className={`snack-chip snack-chip-border-radius-${borderRadius} ${theme}-chip ${getClasses(
        { active: isActive }
      )} ${getClasses({ "neutral-text": Boolean(options?.colorTextNeutral) })}`}
    >
      {iconLeft && renderIcon(iconLeft)}
      <span className={`${customSpanClass}`}>{label}</span>
      {iconRight && renderIcon(iconRight)}
    </button>
  ) : (
    <div
      style={{ backgroundColor: backgroundColor, color: color }}
      className={`snack-chip snack-chip-border-radius-${borderRadius} ${theme}-chip ${getClasses(
        { "neutral-text": Boolean(options?.colorTextNeutral) }
      )}`}
    >
      {iconLeft && renderIcon(iconLeft)}
      <span className={`${customSpanClass}`}>{label}</span>
      {iconRight && renderIcon(iconRight)}
    </div>
  );
};

export default SnackChip;
